import { isCancel } from 'axios';

/**
 * 요청이 **취소/중단**되어 실패한 것인지 판정한다.
 *
 * axios 는 취소를 `CanceledError`(= `AxiosError` 서브클래스, `__CANCEL__` 마킹)로 낸다.
 * 그런데 `CancelToken.source().cancel()` 로 만든 취소는 요청이 전송되기 전에 끊길 수 있어
 * `error.request` 가 없고, 그러면 `ErrorInterceptorTemplate` 의
 * `if (!e.request || e.message === ERR_NETWORK) → NetworkError` 분기에 걸려
 * **전송 실패(NetworkError)로 승격**된다. 승격되면 `defaultQueryPolicy.throwOnErrorCondition`
 * 이 `NetworkError` 만 보므로 React 에러 바운더리까지 올라가 전체 화면이 에러로 덮인다.
 * 취소는 장애가 아니라 정상 흐름(언마운트·네비게이션·큐 정리)이므로 그 앞에서 걸러야 한다.
 *
 * `isCancel` 하나로는 부족하다 — `AbortController.abort()` 경로는 `ERR_CANCELED` 코드로,
 * fetch 계열 abort 는 `AbortError` 이름으로 올라올 수 있어 셋을 함께 본다.
 */
export function isCanceledRequest(error: unknown): boolean {
  if (isCancel(error)) return true;

  const candidate = error as { code?: unknown; name?: unknown } | null | undefined;

  return candidate?.code === 'ERR_CANCELED' || candidate?.name === 'AbortError';
}
